var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpikeArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 349,
    viewBox: "0 0 603 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 347.244L94.9849 219.036C97.2724 215.882 101.567 214.955 104.952 216.883L222.492 283.846C226.119 285.912 230.733 284.685 232.855 281.09L328.376 119.194C330.508 115.581 335.154 114.363 338.784 116.464L454.063 183.198C457.519 185.199 461.934 184.2 464.192 180.906L571.641 24.1875",
    stroke: "url(#paint0_linear_8812_12593)",
    strokeWidth: 3.27454,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M513.118 46.5069L572.033 20.9197C573.024 20.4893 574.122 21.2508 574.066 22.3297L570.751 86.475",
    stroke: "url(#paint1_linear_8812_12593)",
    strokeWidth: 3.27454,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8812_12593",
    x1: 519.828,
    y1: 101.36,
    x2: 75.7784,
    y2: 429.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F034A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F034A6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8812_12593",
    x1: 574.187,
    y1: 19.9841,
    x2: 541.935,
    y2: 66.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F034A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F034A6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeArrow);
export default __webpack_public_path__ + "static/media/spike-arrow.cfe4e455811a40042d0571e5866bbef9.svg";
export { ForwardRef as ReactComponent };